export const AI_VISIBILITY_RUN_PROGRESS_STARTED = 'ai-visibility-run-progress-started'
export const AI_VISIBILITY_RUN_PROGRESS_COMPLETED = 'ai-visibility-run-progress-completed'
